import type { MouseEvent } from 'react';

import type { Notification } from '@enterprise/api';
import { isNotDefined } from '@enterprise/core';

import { outcomePresentation } from '@hooks/notifier/outcome-presentation';

import type { NotificationRowConfiguration } from './types/notification-row-configuration.type';

export const useNotificationRowConfiguration = (
  notification: Notification,
  onOpen: (notification: Notification) => void,
  onDelete: (id: number) => void
): NotificationRowConfiguration => {
  const isUnread = isNotDefined(notification.readDate);
  const presentation = outcomePresentation(notification.outcome);
  const Icon = presentation.icon;
  const isRunning = notification.outcome === 'running';

  const handleOpen = () => {
    onOpen(notification);
  };

  const handleDelete = (e: MouseEvent) => {
    e.stopPropagation();
    onDelete(notification.id);
  };

  return {
    handleDelete,
    handleOpen,
    Icon,
    isRunning,
    isUnread,
    presentation,
  };
};
